export const APP_CONTENT_MAX_WIDTH = 1200;
